import Auth from './components/page/login.vue';
import Moteur from './components/page/moteur.vue';
import Moteurs from './components/page/moteurs.vue';
import Site from './components/page/site.vue';
import Sites from './components/page/sites.vue';
import Welcome from './components/page/welcome.vue';
import Page from './components/page/page.vue';
import Simulations from './components/page/simulations.vue';
import Simulation from './components/page/simulation.vue';
import Report from './components/page/report/index.vue';
import resetPassword from './components/page/resetPassword.vue';

export default {
    routes: [
        {
            path: '/login',
            component: Auth,
            name: 'login',
        },
        {
            path: '/reset-password/',
            component: resetPassword,
            name: 'reset-password',
        },
        {
            path: '/',
            component: Welcome,
            name: 'home',
        },
        {
            path: '/audits/',
            component: Sites,
            name: 'sites',
        },
        {
            path: '/audit/:uid?',
            component: Site,
            name: 'site',
        },
        {
            path: '/moteur/:siteid/:uid?',
            component: Moteur,
            name: 'moteur',
        },
        {
            path: '/moteurs/:siteid',
            component: Moteurs,
            name: 'moteurs',
        },
        {
            path: '/simulations/',
            component: Simulations,
            name: 'simulations',
        },
        {
            path: '/simulation/:uid',
            component: Simulation,
            name: 'simulation',
        },
        {
            path: '/report/:modelName/:auditId/:reportId?',
            component: Report,
            name: 'report',
        },
        {
            path: '/mentions/',
            component: Page,
            name: 'mentions',
        },
        // le path * doit toujours être à la fin
        {
            path: '*',
            component: require('./components/page/404.vue'),
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router.js